import { FC, useState } from 'react';
import { ContractsFilterContainer } from './shared/ContractsFilterContainer';
import { ContractsFilterSection } from './shared/ContractsFilterSection';
import { ContractsFilterAmountRange } from './shared/ContractsFilterAmountRange';
import styles from './shared/ContractsFilterContainer.module.scss';

export interface PriceFilterProps {
  minValue?: number;
  maxValue?: number;
  onChange: (min?: number, max?: number) => void;
  onReset: () => void;
  onApply: () => void;
  show?: boolean;
}

export const ContractsPriceFilter: FC<PriceFilterProps> = ({
  minValue,
  maxValue,
  onChange,
  show,
}) => {
  const [localMin, setLocalMin] = useState<string>(minValue?.toString() || '');
  const [localMax, setLocalMax] = useState<string>(maxValue?.toString() || '');

  const handleMinChange = (value: string | number) => {
    const stringValue = String(value);
    setLocalMin(stringValue);
    const numValue = stringValue === '' ? undefined : Number(stringValue);
    onChange(numValue, maxValue);
  };

  const handleMaxChange = (value: string | number) => {
    const stringValue = String(value);
    setLocalMax(stringValue);
    const numValue = stringValue === '' ? undefined : Number(stringValue);
    onChange(minValue, numValue);
  };

  return (
    <ContractsFilterContainer className={styles.amount}>
      <ContractsFilterSection>
        <ContractsFilterAmountRange
          show={show}
          fromValue={localMin}
          toValue={localMax}
          onFromChange={handleMinChange}
          onToChange={handleMaxChange}
          fromPlaceholder='0'
          toPlaceholder='1 000 000'
          hideSearchIcon={true}
        />
      </ContractsFilterSection>
    </ContractsFilterContainer>
  );
};
